var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('InfoAlert',{attrs:{"showDismissibleAlert":_vm.showDismissibleAlert,"info":_vm.info},on:{"close":function($event){_vm.showDismissibleAlert = false}}}),_c('v-row',[_c('v-col',[_c('ManufacturingLogbookCountStats')],1)],1),_c('v-row',[_c('v-col',[_c('ManufacturingLogbookTimeStats')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }